import styled from 'styled-components';

const StyledFilterTabs = styled.div`
  button {
    padding: ${(props) => props.padding ?? '8px'};
    background-color: white;
    border: 1.5px solid ${({ theme }) => theme.inputBorder};
    display: flex;
    align-items: center;
    &:active,
    &:focus,
    &.active {
      color: ${({ theme }) => theme.darkText};
      border: ${({ theme, props }) =>
        theme?.dark
          ? `1.5px solid ${theme.primaryDark}`
          : `1.5px solid ${theme.secondary}`};
      background-color: ${({ theme }) => theme.secondaryLight2};
    }
    &:hover {
      border: ${({ theme, props }) => `1.5px solid ${theme.secondaryLight}`};
      background-color: ${({ theme }) => theme.secondaryLight} !important;
    }
    &.not-active {
      background-color: ${({ theme }) => theme.white};
      border: ${({ theme, props }) => `1.5px solid ${theme.inputBorder}`};
    }
  }
`;

export default StyledFilterTabs;
